<template>
	<v-time-picker
		:value="value"
		:locale="locale"
		:scrollable="scrollable"
		:format="format"
		v-bind="$attrs"
		v-on="unhandled_events"
		@input="on_input"
	>
		<slot />
	</v-time-picker>
</template>

<script>
export default {
	name: 'KTimePicker',
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			default: null
		},
		locale: {
			type: String,
			default: undefined
		},
		scrollable: {
			type: Boolean,
			default: false
		},
		format: {
			type: String,
			default: 'ampm'
		}
	},
	methods: {
		on_input(value) {
			this.$emit('input', value)
		}
	},
	computed: {
		unhandled_events() {
			const { input, ...listeners } = this.$listeners
			return listeners
		}
	}
};
</script>
